import { getAltParts } from "../components/Wrapper";

const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect


export function aswoToPart(aswo) {
    const part = {}
    part.id = aswo.Artikelnummer.toString()
    part.partNumber = aswo.Artikelnummer
    part.description = aswo.Artikelbezeichnung
    part.manufactureCode = aswo.Originalnummer !== undefined ? aswo.Originalnummer : ""
    part.fullManufactureCode = aswo.Originalnummer !== undefined ? aswo.Originalnummer : ""
    part.brand = aswo.Hersteller
    part.cart = false
    part.group = aswo.Artikelgruppe
    // part.= aswo.Vergleichsartikel
    // part.= aswo.staffelpreise
    // part.= aswo.Bestellbar
    part.unitPrice = aswo.Stueckpreis == 0 ? "N/A" : +aswo.Stueckpreis
    part.fullPrice = aswo.Bruttopreis == 0 ? "N/A" : +aswo.Bruttopreis
    // part.= aswo.Lieferzeit
    // part.= aswo.Lagerbestand
    // part.= aswo.deliverytimedays
    // part.= aswo.Grossteileaufschlag
    part.deliverytimedays = aswo.deliverytimedays
    part.obsolete = aswo.deliverytimedays == -1
    part.specialOrder = aswo.deliverytimedays >= 1
    part.specialOrderTwoWeeks = aswo.deliverytimedays >= 1 && aswo.deliverytimedays <= 14
    part.inStock = (aswo.deliverytimedays == 0).toString()
    part.imageThumbnail = aswo.Artikelthumbnail
    part.image = aswo.Artikelthumbnail
    part.positionNumber = aswo.positionsnummern !== undefined ? aswo.positionsnummern.join("") : "0"
    part.supplier = ASWOProvider
    part.supplierName = ASWOProvider.name
    part.hasAlts = false
    part.alternative = ""
    part.qty = 1
    part.warehouseStock = null
    part.sortOrder = 3

    // part.= aswo.Lagerbestand1
    // part.= aswo.Lagerbestand2
    return part
}
export async function aswoToPartWithAlternative(aswo) {
    const part = {}
    part.id = aswo.Artikelnummer.toString()
    part.partNumber = aswo.Artikelnummer
    part.description = aswo.Artikelbezeichnung
    part.manufactureCode = aswo.Originalnummer
    part.brand = aswo.Hersteller
    part.cart = false
    // part.=aswo.Artikelgruppe
    // part.= aswo.Vergleichsartikel
    // part.= aswo.staffelpreise
    // part.= aswo.Bestellbar
    part.unitPrice = aswo.Stueckpreis == 0 ? "N/A" : +aswo.Stueckpreis
    part.fullPrice = aswo.Bruttopreis == 0 ? "N/A" : +aswo.Bruttopreis
    // part.= aswo.Lieferzeit
    // part.= aswo.Lagerbestand
    // part.= aswo.deliverytimedays
    // part.= aswo.Grossteileaufschlag
    part.obsolete = aswo.deliverytimedays == -1
    part.specialOrder = aswo.deliverytimedays >= 1
    part.inStock = (aswo.deliverytimedays == 0).toString()
    part.imageThumbnail = aswo.Artikelthumbnail
    part.image = aswo.Artikelthumbnail
    part.positionNumber = aswo.positionsnummern !== undefined ? aswo.positionsnummern.join("") : "0"
    part.supplier = ASWOProvider
    part.supplierName = ASWOProvider.name
    part.hasAlts = false
    part.alternative = await getAltParts(aswo.Artikelnummer)
    part.qty = 1
    part.warehouseStock = null
    part.sortOrder = 3

    // part.= aswo.Lagerbestand1
    // part.= aswo.Lagerbestand2
    console.log(part);
    return part
}
export function connectToPart(connect) {
    const part = {}
    part.id = connect.id ? connect.id.toString() : ""
    part.partNumber = connect.sku
    part.description = connect.mainHeader
    part.manufactureCode = connect.manufacturerPartNumber !== undefined ? connect.manufacturerPartNumber.match(/\d\D{3,4}(\w+)$/) ? connect.manufacturerPartNumber.match(/\d\D{3,4}(\w+)$/)[1] : connect.manufacturerPartNumber.substring(3) : ""
    part.fullManufactureCode = connect.manufacturerPartNumber !== undefined ? connect.manufacturerPartNumber : ""

    part.brand = connect.brand
    part.cart = false
    part.group = connect.mainHeader
    part.unitPrice = connect.price ? +connect.price.breaks[0].price : "N/A"
    part.fullPrice = connect.ssp ? +connect.ssp.price : "N/A"
    part.obsolete = connect.obsolete
    part.specialOrder = connect.specialOrder
    part.specialOrderTwoWeeks = false
    part.inStock = connect.inStock ? connect.inStock.toString() : "false"
    part.imageThumbnail = connect.imageThumbnail
    part.image = connect.image
    part.images = connect.images
    part.positionNumber = "0"
    part.supplier = ConnectProvider
    part.supplierName = ConnectProvider.name
    part.hasAlts = false
    part.alternative = ""
    part.qty = 1
    part.warehouseStock = null
    part.sortOrder = 3
    // part.suom = connect.suom
    // part.qty = connect.qty


    return part
}